
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/branch/[slug]",
      function () {
        return require("private-next-pages/branch/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/branch/[slug]"])
      });
    }
  